import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { apiClient } from '../../services/api';

interface AnalyticsState {
  metrics: any;
  loading: boolean;
  error: string | null;
}

const initialState: AnalyticsState = {
  metrics: null,
  loading: false,
  error: null,
};

export const fetchAnalytics = createAsyncThunk(
  'analytics/fetch',
  async ({ tenantId, startDate, endDate }: { tenantId: string; startDate: string; endDate: string }, { rejectWithValue }) => {
    try {
      return await apiClient.get('/analytics/metrics', { params: { tenantId, startDate, endDate } });
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.error || 'Failed to fetch analytics');
    }
  }
);

export const exportReport = createAsyncThunk(
  'analytics/export',
  async ({ tenantId, format }: { tenantId: string; format: string }, { rejectWithValue }) => {
    try {
      const response = await apiClient.post('/analytics/export', { tenantId, format }, { responseType: 'blob' });
      return response;
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.error || 'Failed to export report');
    }
  }
);

const analyticsSlice = createSlice({
  name: 'analytics',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAnalytics.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAnalytics.fulfilled, (state, action) => {
        state.loading = false;
        state.metrics = action.payload;
      })
      .addCase(fetchAnalytics.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export default analyticsSlice.reducer;
